// extracted by mini-css-extract-plugin
export default {"content-right":"ContentRight_content-right__HtOez","item":"ContentRight_item__YnYhi","content-hot":"ContentRight_content-hot__QDnn8"};